import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import axios from "axios";
import { API_ROOT } from "../service/Services";

export default function SalesTeam() {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalData, setTotalData] = useState(0);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploading, setUploading] = useState(false);

  // Search and Filter States
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [filters, setFilters] = useState({
    company: "",
    title: "",
    email: "",
    contact: "",
  });
  const [debouncedFilters, setDebouncedFilters] = useState({
    company: "",
    title: "",
    email: "",
    contact: "",
  });
  const [showFilters, setShowFilters] = useState(false);

  // Mail services (multi-account config) + Send mail
  const [mailServices, setMailServices] = useState([]);
  const [showMailServiceModal, setShowMailServiceModal] = useState(false);
  const [editingMailService, setEditingMailService] = useState(null);
  const [mailServiceForm, setMailServiceForm] = useState({
    name: "",
    type: "gmail",
    configKey: "EMAIL_USER",
    maxPerWindow: 100,
    windowMinutes: 15,
    delayBetweenEmailsMs: 0,
    isActive: true,
    order: 0,
    user: "",
    pass: "",
    host: "",
    port: 587,
  });
  const [showSendMailModal, setShowSendMailModal] = useState(false);
  const [sendMailForm, setSendMailForm] = useState({
    subject: "",
    body: "",
    html: "",
    sendTo: "page",
    rowSelection: "",
    when: "now",
    scheduleDate: "",
    scheduleTime: "09:00",
    timezone: "Asia/Kolkata",
    templateId: "",
    topic: "",
    serviceIds: [],
    signatureId: "",
  });
  const [sendingMail, setSendingMail] = useState(false);
  const [campaignToken, setCampaignToken] = useState(null);
  const [campaignStatus, setCampaignStatus] = useState(null);
  const [testEmail, setTestEmail] = useState("");
  const [sendingTest, setSendingTest] = useState(false);
  const [mailSignatures, setMailSignatures] = useState([]);
  const [showSignatureModal, setShowSignatureModal] = useState(false);
  const [editingSignature, setEditingSignature] = useState(null);
  const [signatureForm, setSignatureForm] = useState({ name: "", content: "", logoUrl: "", isDefault: false });
  const [showConfigSidebar, setShowConfigSidebar] = useState(false);
  const [scheduledCampaigns, setScheduledCampaigns] = useState([]);
  const [mailTemplates, setMailTemplates] = useState([]);
  const [showTemplateModal, setShowTemplateModal] = useState(false);
  const [editingTemplate, setEditingTemplate] = useState(null);
  const [templateForm, setTemplateForm] = useState({ name: "", subject: "", body: "", html: "" });
  const [mailHistoryRow, setMailHistoryRow] = useState(null);
  const [sendCapacity, setSendCapacity] = useState({ services: [], totalRecommended: 0, note: "" });
  const [sendCapacityLoading, setSendCapacityLoading] = useState(false);

  // Rows per page (now selectable) — default 10
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const ROWS_PER_PAGE_OPTIONS = [10, 50, 100];

  const UPLOAD_CHUNK_SIZE = 2000; // Optimized chunk size for large uploads (backend processes 1000 per chunk)

  // Best-option defaults for Gmail / mail configuration (suggested in sidebar)
  const MAIL_CONFIG_DEFAULTS = {
    gmail: "Gmail: max 100 emails per 15 min, 1s delay between emails (recommended for deliverability).",
    office365: "Office 365: max 200 per hour or 10,000 per day. Use delay 500ms for hourly limit.",
    custom: "Custom SMTP: start with 50 per 15 min, 1.5s delay; increase after testing.",
  };

  const TIMEZONE_OPTIONS = [
    { value: "Asia/Kolkata", label: "India (IST)" },
    { value: "UTC", label: "UTC" },
    { value: "America/New_York", label: "Eastern (ET)" },
    { value: "America/Los_Angeles", label: "Pacific (PT)" },
    { value: "Europe/London", label: "London (GMT/BST)" },
  ];

  // Suggested rate-limit presets for best performance (provider limits)
  const MAIL_SERVICE_PRESETS = [
    { label: "Gmail – 100 per 15 min (recommended)", maxPerWindow: 100, windowMinutes: 15, delayBetweenEmailsMs: 1000 },
    { label: "Gmail – 500 per day (conservative)", maxPerWindow: 500, windowMinutes: 1440, delayBetweenEmailsMs: 2000 },
    { label: "Office 365 – 200 per hour", maxPerWindow: 200, windowMinutes: 60, delayBetweenEmailsMs: 500 },
    { label: "Office 365 – 10,000 per day", maxPerWindow: 10000, windowMinutes: 1440, delayBetweenEmailsMs: 0 },
    { label: "SendGrid-style – 500 per hour", maxPerWindow: 500, windowMinutes: 60, delayBetweenEmailsMs: 0 },
    { label: "Custom – 50 per 15 min (safe)", maxPerWindow: 50, windowMinutes: 15, delayBetweenEmailsMs: 1500 },
  ];

  // const allowedFields = [
  //   { key: "firstName", label: "First Name" },
  //   { key: "lastName", label: "Last Name" },
  //   { key: "title", label: "Title" },
  //   { key: "company", label: "Company" },
  //   { key: "email", label: "Email" },
  //   { key: "contact", label: "Phone" },
  //   { key: "personalLinkedinURL", label: "LinkedIn" },
  //   { key: "website", label: "Website" },
  //   { key: "companyLinkedinURL", label: "Company LinkedIn" },
  //   { key: "facebookURL", label: "Facebook" },
  //   { key: "twitterURL", label: "Twitter" },
  // ];

const allowedFields = [ { key: "firstName", label: "First Name" }, { key: "lastName", label: "Last Name" }, { key: "title", label: "Title" }, { key: "company", label: "Company Name" }, { key: "email", label: "Email" }, { key: "contact", label: "Corporate Phone" }, { key: "personalLinkedinURL", label: "Person Linkedin Url" }, { key: "website", label: "Website" }, { key: "companyLinkedinURL", label: "Company Linkedin Url" }, { key: "facebookURL", label: "Facebook Url" }, { key: "twitterURL", label: "Twitter Url" }, ];


  const authHeaders = useMemo(
    () => ({
      headers: {
        authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }),
    []
  );

  /* ================= DEBOUNCE SEARCH ================= */
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(searchQuery);
    }, 500);

    return () => clearTimeout(timer);
  }, [searchQuery]);

  /* ================= DEBOUNCE FILTERS ================= */
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedFilters(filters);
    }, 500);

    return () => clearTimeout(timer);
  }, [filters]);

  /* ================= FETCH DATA ================= */
  const fetchSales = async (page = 1, search = "", filterParams = {}, signal, limit = rowsPerPage) => {
    try {
      const queryParams = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
      });

      if (search.trim()) {
        queryParams.append("search", search.trim());
      }

      // Add filter parameters
      if (filterParams.company?.trim()) {
        queryParams.append("company", filterParams.company.trim());
      }
      if (filterParams.title?.trim()) {
        queryParams.append("title", filterParams.title.trim());
      }
      if (filterParams.email?.trim()) {
        queryParams.append("email", filterParams.email.trim());
      }
      if (filterParams.contact?.trim()) {
        queryParams.append("contact", filterParams.contact.trim());
      }

      const res = await axios.get(
        `${API_ROOT}/sales?${queryParams.toString()}`,
        { ...authHeaders, signal }
      );

      if (res.data?.success) {
        setRows(res.data.data);
        setTotalPages(res.data.pagination.totalPages);
        setTotalData(res.data.pagination.total);
      }
    } catch (err) {
      if (axios.isCancel(err)) return;
      console.error(err);
    }
  };

  // Reset to first page when search or filters change
  useEffect(() => {
    setCurrentPage(1);
  }, [debouncedSearch, debouncedFilters]);

  // Fetch data when page, search, filters, or rowsPerPage change (cancel previous request)
  useEffect(() => {
    const ac = new AbortController();
    fetchSales(currentPage, debouncedSearch, debouncedFilters, ac.signal, rowsPerPage);
    return () => ac.abort();
  }, [currentPage, debouncedSearch, debouncedFilters, rowsPerPage]);

  // Fetch mail service configs
  const fetchMailServices = async () => {
    try {
      const res = await axios.get(`${API_ROOT}/mail-services`, authHeaders);
      if (res.data?.success) setMailServices(res.data.data || []);
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    fetchMailServices();
  }, []);

  /** Fetch 24h send capacity for selected (or all active) mail service IDs. Backend stores limits in DB (universal policy). */
  const fetchSendCapacity = async (serviceIds = null) => {
    setSendCapacityLoading(true);
    try {
      const params = {};
      if (Array.isArray(serviceIds) && serviceIds.length > 0) {
        params.serviceIds = serviceIds.join(",");
      }
      const res = await axios.get(`${API_ROOT}/mail-services/send-capacity`, { ...authHeaders, params });
      if (res.data?.success && res.data.data) {
        setSendCapacity({
          services: res.data.data.services || [],
          totalRecommended: res.data.data.totalRecommended ?? 0,
          note: res.data.data.note || "",
        });
      } else {
        setSendCapacity({ services: [], totalRecommended: 0, note: "" });
      }
    } catch (err) {
      console.error(err);
      setSendCapacity({ services: [], totalRecommended: 0, note: "" });
    } finally {
      setSendCapacityLoading(false);
    }
  };

  const fetchScheduledCampaigns = async () => {
    try {
      const res = await axios.get(`${API_ROOT}/scheduled-campaigns`, authHeaders);
      if (res.data?.success) setScheduledCampaigns(res.data.data || []);
    } catch (err) {
      console.error(err);
    }
  };

  const cancelScheduledCampaign = async (id) => {
    if (!window.confirm("Cancel this scheduled campaign?")) return;
    try {
      await axios.delete(`${API_ROOT}/scheduled-campaigns/${id}`, authHeaders);
      fetchScheduledCampaigns();
    } catch (err) {
      alert(err.response?.data?.message || "Cancel failed");
    }
  };

  const getTomorrowDate = () => {
    const d = new Date();
    d.setDate(d.getDate() + 1);
    return d.toISOString().slice(0, 10);
  };

  const TEMPLATE_PLACEHOLDERS = "{{firstName}}, {{lastName}}, {{company}}, {{email}}, {{title}}, {{contact}}, {{website}}, {{name}} (from data leads)";
  const PLACEHOLDER_EXAMPLE = "{{firstName}}";
  const PLACEHOLDER_COMPANY = "{{company}}";

  /**
   * Parse printer-style row selection using rowNumber (counter-based).
   * "1-34", "15-3" (same as 3-15), "3, 5-12" → returns matching row objects.
   * Uses actual rowNumber from data, not page-based indices.
   */
  const parseRowSelectionByRowNumber = (str, allRows) => {
    if (!str || !String(str).trim() || !Array.isArray(allRows) || allRows.length === 0) return [];
    const seenNumbers = new Set();
    String(str)
      .split(/[,;\s]+/)
      .forEach((part) => {
        const trimmed = part.trim();
        if (!trimmed) return;
        if (trimmed.includes("-")) {
          const [a, b] = trimmed.split("-").map((n) => parseInt(n, 10));
          if (!Number.isNaN(a) && !Number.isNaN(b)) {
            const low = Math.min(a, b);
            const high = Math.max(a, b);
            for (let i = low; i <= high; i++) seenNumbers.add(i);
          }
        } else {
          const n = parseInt(trimmed, 10);
          if (!Number.isNaN(n) && n >= 1) seenNumbers.add(n);
        }
      });

    // Filter rows by rowNumber
    return allRows.filter((row) => row.rowNumber != null && seenNumbers.has(row.rowNumber));
  };

  /**
   * Parse row selection using rowNumber (counter-based).
   * Returns matching rows and their rowNumbers.
   * For "pageSelection": uses rows from current page if all match, otherwise fetches from filter.
   */
  const getParsedRowSelection = () => {
    if (sendMailForm.sendTo !== "pageSelection" || !sendMailForm.rowSelection?.trim()) {
      return { selectedRows: [], rowNumbers: [], minRowNumber: 0, maxRowNumber: 0, isBeyondPage: false };
    }

    // Parse rowNumbers from input string
    const seenNumbers = new Set();
    String(sendMailForm.rowSelection)
      .split(/[,;\s]+/)
      .forEach((part) => {
        const trimmed = part.trim();
        if (!trimmed) return;
        if (trimmed.includes("-")) {
          const [a, b] = trimmed.split("-").map((n) => parseInt(n, 10));
          if (!Number.isNaN(a) && !Number.isNaN(b)) {
            const low = Math.min(a, b);
            const high = Math.max(a, b);
            for (let i = low; i <= high; i++) seenNumbers.add(i);
          }
        } else {
          const n = parseInt(trimmed, 10);
          if (!Number.isNaN(n) && n >= 1) seenNumbers.add(n);
        }
      });

    const rowNumbers = [...seenNumbers].sort((a, b) => a - b);
    if (rowNumbers.length === 0) {
      return { selectedRows: [], rowNumbers: [], minRowNumber: 0, maxRowNumber: 0, isBeyondPage: false };
    }

    const minRowNumber = Math.min(...rowNumbers);
    const maxRowNumber = Math.max(...rowNumbers);

    // Check if all selected rowNumbers are in current page
    const pageRowNumbers = new Set(rows.map((r) => r.rowNumber).filter((n) => n != null));
    const allInPage = rowNumbers.every((n) => pageRowNumbers.has(n));

    if (allInPage) {
      const selectedRows = rows.filter((r) => r.rowNumber != null && seenNumbers.has(r.rowNumber));
      return { selectedRows, rowNumbers, minRowNumber, maxRowNumber, isBeyondPage: false };
    } else {
      // Resolved server-side via filter + rowSelection (no frontend fetch for lakhs of rows)
      return { selectedRows: [], rowNumbers, minRowNumber, maxRowNumber, isBeyondPage: true };
    }
  };

  const parsedRowSelection = getParsedRowSelection();

  /** Get contact IDs for current send: page all, page selection (by rowNumber), or filter. When isBeyondPage we send filter+rowSelection and backend resolves IDs. */
  const getSendMailContactIds = () => {
    if (sendMailForm.sendTo === "filter") return null;
    if (sendMailForm.sendTo === "pageSelection" && sendMailForm.rowSelection?.trim()) {
      if (parsedRowSelection.isBeyondPage) return null; // backend resolves from filter + rowSelection
      return parsedRowSelection.selectedRows.map((r) => r._id).filter(Boolean);
    }
    return rows.map((r) => r._id);
  };

  const sendMailContactIds = getSendMailContactIds();
  const sendMailSelectedCount =
    sendMailForm.sendTo === "pageSelection" && parsedRowSelection.isBeyondPage
      ? parsedRowSelection.rowNumbers.length
      : Array.isArray(sendMailContactIds)
        ? sendMailContactIds.length
        : sendMailForm.sendTo === "filter"
          ? totalData
          : 0;
  const sendMailSelectedRows =
    sendMailForm.sendTo === "pageSelection" && sendMailForm.rowSelection?.trim()
      ? parsedRowSelection.isBeyondPage
        ? null
        : parsedRowSelection.selectedRows
      : sendMailForm.sendTo === "page"
        ? rows
        : null;

  const ROW_SELECTION_CAP = 50000;
  const LARGE_SEND_CONFIRM_THRESHOLD = 500;

  /**
   * Validation for Send mail. Returns { valid, errors[] }.
   * Use forTestEmail: true to skip recipient/schedule checks (test email only).
   */
  const validateSendMail = (opts = {}) => {
    const { forTestEmail = false } = opts;
    const errors = [];
    const subject = (sendMailForm.subject ?? "").trim();
    const body = (sendMailForm.body ?? "").trim();
    const html = (sendMailForm.html ?? "").trim();
    const hasSubject = subject.length > 0;
    const hasBody = body.length > 0;
    const hasHtml = html.length > 0;

    if (!hasSubject) errors.push("Subject is required.");
    if (!hasBody && !hasHtml) errors.push("Provide Body (plain text) or HTML content.");
    if (!sendMailForm.signatureId || !String(sendMailForm.signatureId).trim()) errors.push("Please select a signature.");
    if (!mailServices.some((s) => s.isActive)) errors.push("Add at least one active email account in Mail config.");

    if (forTestEmail) return { valid: errors.length === 0, errors };

    // Recipients
    if (sendMailForm.sendTo === "page") {
      if (!rows.length) errors.push("Current page has no contacts. Change page or use a filter.");
    } else if (sendMailForm.sendTo === "filter") {
      if (totalData === 0) errors.push("No contacts match the current filter. Adjust filters or choose another option.");
    } else if (sendMailForm.sendTo === "pageSelection") {
      const rs = sendMailForm.rowSelection?.trim();
      if (!rs) errors.push("Enter row numbers (e.g. 1-100 or 1, 2, 5-10).");
      else if (parsedRowSelection.rowNumbers.length === 0) errors.push("Row selection didn't match any valid rows. Use format: 1-100 or 1, 2, 5-10.");
      else if (parsedRowSelection.rowNumbers.length > ROW_SELECTION_CAP) errors.push(`Row selection is capped at ${ROW_SELECTION_CAP.toLocaleString()} contacts. You have ${parsedRowSelection.rowNumbers.length.toLocaleString()} selected.`);
      else if (!parsedRowSelection.isBeyondPage && (!sendMailContactIds || sendMailContactIds.length === 0)) errors.push("No contacts selected for the given row numbers on this page.");
    }

    // Schedule
    const isScheduled = sendMailForm.when === "schedule" && sendMailForm.scheduleDate && sendMailForm.scheduleTime;
    if (isScheduled) {
      const dateStr = String(sendMailForm.scheduleDate).trim();
      const timeStr = String(sendMailForm.scheduleTime).trim();
      if (!/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) errors.push("Schedule date must be in YYYY-MM-DD format.");
      else if (!/^\d{1,2}:\d{2}$/.test(timeStr)) errors.push("Schedule time must be in HH:MM format.");
      else {
        const [y, m, d] = dateStr.split("-").map(Number);
        const [hr, min] = timeStr.split(":").map(Number);
        const offset = timezoneOffsetMinutes[sendMailForm.timezone] ?? 0;
        const sendAt = new Date(Date.UTC(y, m - 1, d, hr, min) - offset * 60 * 1000);
        if (Number.isNaN(sendAt.getTime())) errors.push("Invalid schedule date or time.");
        else if (sendAt.getTime() <= Date.now()) errors.push("Schedule time must be in the future.");
      }
    }

    return { valid: errors.length === 0, errors };
  };

  const showValidationAlert = (errors) => {
    if (!Array.isArray(errors) || errors.length === 0) return;
    const title = "Send mail";
    const message = errors.length === 1 ? errors[0] : `Please fix the following:\n\n• ${errors.join("\n• ")}`;
    alert(`${title}\n\n${message}`);
  };

  const fetchMailTemplates = async () => {
    try {
      const res = await axios.get(`${API_ROOT}/mail-templates`, authHeaders);
      if (res.data?.success) setMailTemplates(res.data.data || []);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchMailSignatures = async () => {
    try {
      const res = await axios.get(`${API_ROOT}/mail-signatures`, authHeaders);
      if (res.data?.success) setMailSignatures(res.data.data || []);
    } catch (err) {
      console.error(err);
    }
  };

  const openAddTemplate = () => {
    setEditingTemplate(null);
    setTemplateForm({ name: "", subject: "", body: "", html: "" });
    setShowTemplateModal(true);
  };

  const openEditTemplate = (t) => {
    setEditingTemplate(t);
    setTemplateForm({
      name: t.name || "",
      subject: t.subject || "",
      body: t.body ?? "",
      html: t.html ?? "",
    });
    setShowTemplateModal(true);
  };

  const saveTemplate = async () => {
    if (!templateForm.name.trim()) {
      alert("Template name is required");
      return;
    }
    try {
      if (editingTemplate) {
        await axios.put(`${API_ROOT}/mail-templates/${editingTemplate._id}`, templateForm, authHeaders);
      } else {
        await axios.post(`${API_ROOT}/mail-templates`, templateForm, authHeaders);
      }
      setShowTemplateModal(false);
      fetchMailTemplates();
    } catch (err) {
      alert(err.response?.data?.message || "Failed to save template");
    }
  };

  const deleteTemplate = async (id) => {
    if (!window.confirm("Delete this template?")) return;
    try {
      await axios.delete(`${API_ROOT}/mail-templates/${id}`, authHeaders);
      fetchMailTemplates();
    } catch (err) {
      alert(err.response?.data?.message || "Delete failed");
    }
  };

  /** Save current Send mail subject/body/html back to the selected template (from Send mail modal). */
  const saveTemplateFromSendModal = async () => {
    const id = sendMailForm.templateId;
    if (!id) return;
    const t = mailTemplates.find((x) => x._id === id);
    if (!t) {
      alert("Template not found.");
      return;
    }
    try {
      await axios.put(
        `${API_ROOT}/mail-templates/${id}`,
        {
          name: t.name,
          subject: sendMailForm.subject,
          body: sendMailForm.body,
          html: sendMailForm.html ?? "",
        },
        authHeaders
      );
      fetchMailTemplates();
      alert("Template updated with current subject, body, and HTML.");
    } catch (err) {
      alert(err.response?.data?.message || "Failed to update template");
    }
  };

  const openAddSignature = () => {
    setEditingSignature(null);
    setSignatureForm({ name: "", content: "", logoUrl: "", isDefault: false });
    setShowSignatureModal(true);
  };
  const openEditSignature = (s) => {
    setEditingSignature(s);
    setSignatureForm({
      name: s.name || "",
      content: s.content || "",
      logoUrl: s.logoUrl || "",
      isDefault: !!s.isDefault,
    });
    setShowSignatureModal(true);
  };
  const saveSignature = async () => {
    if (!signatureForm.name.trim()) {
      alert("Signature name is required");
      return;
    }
    try {
      if (editingSignature) {
        await axios.put(`${API_ROOT}/mail-signatures/${editingSignature._id}`, signatureForm, authHeaders);
      } else {
        await axios.post(`${API_ROOT}/mail-signatures`, signatureForm, authHeaders);
      }
      setShowSignatureModal(false);
      fetchMailSignatures();
    } catch (err) {
      alert(err.response?.data?.message || "Failed to save signature");
    }
  };
  const deleteSignature = async (id) => {
    if (!window.confirm("Delete this signature?")) return;
    try {
      await axios.delete(`${API_ROOT}/mail-signatures/${id}`, authHeaders);
      fetchMailSignatures();
    } catch (err) {
      alert(err.response?.data?.message || "Delete failed");
    }
  };

  const openAddMailService = () => {
    setEditingMailService(null);
    setMailServiceForm({
      name: "",
      type: "gmail",
      configKey: "EMAIL_USER",
      maxPerWindow: 100,
      windowMinutes: 15,
      delayBetweenEmailsMs: 1000,
      maxPer24h: "",
      isActive: true,
      order: mailServices.length,
      user: "",
      pass: "",
      host: "",
      port: 587,
    });
    setShowMailServiceModal(true);
  };
  const openEditMailService = (s) => {
    setEditingMailService(s);
    setMailServiceForm({
      name: s.name || "",
      type: s.type || "gmail",
      configKey: s.configKey || "EMAIL_USER",
      maxPerWindow: s.maxPerWindow ?? 100,
      windowMinutes: s.windowMinutes ?? 15,
      delayBetweenEmailsMs: s.delayBetweenEmailsMs ?? 0,
      maxPer24h: s.maxPer24h ?? "",
      isActive: s.isActive !== false,
      order: s.order ?? 0,
      user: s.user || "",
      pass: "",
      host: s.host || "",
      port: s.port ?? 587,
    });
    setShowMailServiceModal(true);
  };
  const saveMailService = async () => {
    try {
      const payload = {
        name: mailServiceForm.name.trim(),
        type: mailServiceForm.type,
        maxPerWindow: mailServiceForm.maxPerWindow,
        windowMinutes: mailServiceForm.windowMinutes,
        delayBetweenEmailsMs: mailServiceForm.delayBetweenEmailsMs || 0,
        isActive: mailServiceForm.isActive,
        order: mailServiceForm.order,
      };
      if (mailServiceForm.maxPer24h === "" || mailServiceForm.maxPer24h == null) {
        payload.maxPer24h = null;
      } else {
        const v = Number(mailServiceForm.maxPer24h);
        if (!Number.isNaN(v) && v >= 1) payload.maxPer24h = v;
      }
      if (mailServiceForm.type === "gmail" || mailServiceForm.type === "office365") {
        payload.configKey = mailServiceForm.configKey;
      } else {
        payload.user = mailServiceForm.user;
        if (mailServiceForm.pass) payload.pass = mailServiceForm.pass;
        payload.host = mailServiceForm.host;
        payload.port = mailServiceForm.port;
      }
      if (editingMailService) {
        await axios.put(`${API_ROOT}/mail-services/${editingMailService._id}`, payload, authHeaders);
      } else {
        await axios.post(`${API_ROOT}/mail-services`, payload, authHeaders);
      }
      setShowMailServiceModal(false);
      fetchMailServices();
    } catch (err) {
      console.error(err);
      alert(err.response?.data?.message || "Failed to save");
    }
  };
  const deleteMailService = async (id) => {
    if (!window.confirm("Delete this email account config?")) return;
    try {
      await axios.delete(`${API_ROOT}/mail-services/${id}`, authHeaders);
      fetchMailServices();
    } catch (err) {
      alert(err.response?.data?.message || "Delete failed");
    }
  };

  const timezoneOffsetMinutes = {
    "Asia/Kolkata": 330,
    UTC: 0,
    "America/New_York": -300,
    "America/Los_Angeles": -480,
    "Europe/London": 0,
  };

  const runSendTestEmail = async () => {
    const email = (testEmail ?? "").trim();
    const testErrors = [];
    if (!email) testErrors.push("Enter an email address to send the test to.");
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) testErrors.push("Enter a valid email address.");
    const contentValidation = validateSendMail({ forTestEmail: true });
    if (!contentValidation.valid) testErrors.push(...contentValidation.errors);
    if (testErrors.length > 0) {
      showValidationAlert(testErrors);
      return;
    }
    setSendingTest(true);
    try {
      const payload = {
        testEmail: email,
        subject: (sendMailForm.subject ?? "").trim(),
        body: (sendMailForm.body ?? "").trim(),
        emailBody: (sendMailForm.body ?? "").trim(),
        html: (sendMailForm.html ?? "").trim() || undefined,
        serviceIds: Array.isArray(sendMailForm.serviceIds) && sendMailForm.serviceIds.length > 0 ? sendMailForm.serviceIds : undefined,
        signatureId: sendMailForm.signatureId,
      };
      if (sendMailForm.templateId) payload.templateId = sendMailForm.templateId;
      const res = await axios.post(`${API_ROOT}/sales/send-campaign-test`, payload, authHeaders);
      alert(`Send mail\n\n${res.data.message || "Test email sent successfully."}`);
    } catch (err) {
      const msg = err.response?.data?.message || err.message || "Test send failed.";
      alert(`Send mail\n\n${msg}`);
    } finally {
      setSendingTest(false);
    }
  };

  const runSendCampaign = async () => {
    const validation = validateSendMail({ forTestEmail: false });
    if (!validation.valid) {
      showValidationAlert(validation.errors);
      return;
    }
    const isScheduled = sendMailForm.when === "schedule" && sendMailForm.scheduleDate && sendMailForm.scheduleTime;
    if (!isScheduled && sendMailSelectedCount > LARGE_SEND_CONFIRM_THRESHOLD) {
      const ok = window.confirm(
        `You are about to send to ${sendMailSelectedCount.toLocaleString()} contact(s). This may take a while.\n\nContinue?`
      );
      if (!ok) return;
    }
    setSendingMail(true);
    try {
      const bodyContent = (sendMailForm.body ?? "").trim();
      const payload = {
        subject: (sendMailForm.subject ?? "").trim(),
        body: bodyContent,
        emailBody: bodyContent, // fallback key in case "body" is stripped by middleware
        html: (sendMailForm.html ?? "").trim() || undefined,
      };
      if (sendMailForm.templateId) payload.templateId = sendMailForm.templateId;
      if (sendMailForm.topic?.trim()) {
        payload.topic = sendMailForm.topic.trim();
      }
      if (Array.isArray(sendMailForm.serviceIds) && sendMailForm.serviceIds.length > 0) {
        payload.serviceIds = sendMailForm.serviceIds;
      }
      payload.signatureId = sendMailForm.signatureId || null;
      if (!isScheduled && sendMailSelectedCount > 1) payload.async = true;
      if (sendMailForm.sendTo === "filter") {
        payload.filter = {
          search: debouncedSearch,
          company: debouncedFilters.company,
          title: debouncedFilters.title,
          email: debouncedFilters.email,
          contact: debouncedFilters.contact,
        };
      } else if (sendMailForm.sendTo === "pageSelection" && parsedRowSelection.isBeyondPage && sendMailForm.rowSelection?.trim()) {
        payload.filter = {
          search: debouncedSearch,
          company: debouncedFilters.company,
          title: debouncedFilters.title,
          email: debouncedFilters.email,
          contact: debouncedFilters.contact,
        };
        payload.rowSelection = sendMailForm.rowSelection.trim();
      } else {
        payload.contactIds = sendMailContactIds || [];
      }
      if (isScheduled) {
        const [y, m, d] = sendMailForm.scheduleDate.split("-").map(Number);
        const [hr, min] = sendMailForm.scheduleTime.split(":").map(Number);
        const offset = timezoneOffsetMinutes[sendMailForm.timezone] ?? 0;
        payload.sendAt = new Date(Date.UTC(y, m - 1, d, hr, min) - offset * 60 * 1000).toISOString();
        payload.timezone = sendMailForm.timezone;
      }
      const res = await axios.post(`${API_ROOT}/sales/send-campaign`, payload, authHeaders);
      if (res.data.scheduled) {
        alert(`Send mail\n\nCampaign scheduled for ${new Date(res.data.sendAt).toLocaleString()}.\nYou can cancel it from the Mail config sidebar.`);
        fetchScheduledCampaigns();
        setShowSendMailModal(false);
        setSendMailForm((f) => ({ ...f, subject: "", body: "", html: "", templateId: "", topic: "", signatureId: "" }));
        setSendingMail(false);
      } else if (res.data.campaignToken) {
        setShowSendMailModal(false);
        setSendMailForm((f) => ({ ...f, subject: "", body: "", html: "", templateId: "", topic: "", signatureId: "" }));
        setSendingMail(false);
        navigate(`/campaign-status/${res.data.campaignToken}`);
      } else {
        alert(`Send mail\n\nDone. Sent: ${res.data.sent}, Failed: ${res.data.failed}, Total: ${res.data.total}`);
        fetchSales(currentPage, debouncedSearch, debouncedFilters, undefined, rowsPerPage);
        setShowSendMailModal(false);
        setSendMailForm((f) => ({ ...f, subject: "", body: "", html: "", templateId: "", topic: "", signatureId: "" }));
        setSendingMail(false);
      }
    } catch (err) {
      const msg = err.response?.data?.message || err.message || "Send failed.";
      alert(`Send mail\n\n${msg}`);
      setSendingMail(false);
    }
  };

  const pollCampaignStatusRef = React.useRef(null);
  useEffect(() => {
    if (!campaignToken) return;
    const poll = async () => {
      try {
        const res = await axios.get(`${API_ROOT}/sales/campaign-status/${campaignToken}`, authHeaders);
        if (res.data?.success) {
          setCampaignStatus({
            status: res.data.status,
            sent: res.data.sent ?? 0,
            failed: res.data.failed ?? 0,
            total: res.data.total ?? 0,
          });
          if (res.data.status === "completed" || res.data.status === "cancelled" || res.data.status === "failed") {
            if (pollCampaignStatusRef.current) clearInterval(pollCampaignStatusRef.current);
            pollCampaignStatusRef.current = null;
            setSendingMail(false);
            setCampaignToken(null);
            const msg =
              res.data.status === "cancelled"
                ? `Send mail\n\nStopped. Sent: ${res.data.sent}, Failed: ${res.data.failed}, Total: ${res.data.total}`
                : res.data.status === "failed"
                  ? "Send mail\n\nCampaign failed."
                  : `Send mail\n\nDone. Sent: ${res.data.sent}, Failed: ${res.data.failed}, Total: ${res.data.total}`;
            alert(msg);
            fetchSales(currentPage, debouncedSearch, debouncedFilters, undefined, rowsPerPage);
            setShowSendMailModal(false);
            setSendMailForm((f) => ({ ...f, subject: "", body: "", html: "", templateId: "", topic: "", signatureId: "" }));
          }
        }
      } catch (_) {}
    };
    pollCampaignStatusRef.current = setInterval(poll, 2000);
    poll();
    return () => {
      if (pollCampaignStatusRef.current) clearInterval(pollCampaignStatusRef.current);
    };
  }, [campaignToken]);

  const stopCurrentCampaign = async () => {
    if (!campaignToken) return;
    try {
      await axios.post(`${API_ROOT}/sales/cancel-campaign`, { campaignToken }, authHeaders);
    } catch (err) {
      console.error(err);
    }
  };

  /* ================= FILTER HELPERS ================= */
  const hasActiveFilters = useMemo(() => {
    return Object.values(filters).some((val) => val.trim() !== "");
  }, [filters]);

  const clearFilters = () => {
    setFilters({
      company: "",
      title: "",
      email: "",
      contact: "",
    });
  };

  const clearSearch = () => {
    setSearchQuery("");
    setDebouncedSearch("");
  };

  /* ================= ROWS PER PAGE ================= */
  const handleRowsPerPageChange = (val) => {
    setRowsPerPage(Number(val));
    setCurrentPage(1);
  };

  /* ================= IMPORT FILE ================= */
  const handleImport = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setUploading(true);
    setUploadProgress(0);

    const reader = new FileReader();

    reader.onload = async (evt) => {
      let sheetData = [];

      if (file.name.endsWith(".csv")) {
        const parsed = XLSX.read(evt.target.result, { type: "string" });
        sheetData = XLSX.utils.sheet_to_json(
          parsed.Sheets[parsed.SheetNames[0]]
        );
      } else {
        const workbook = XLSX.read(evt.target.result, { type: "binary" });
        sheetData = XLSX.utils.sheet_to_json(
          workbook.Sheets[workbook.SheetNames[0]]
        );
      }

      if (!sheetData.length) {
        alert("File is empty");
        setUploading(false);
        return;
      }

      // Helper to get value from row with multiple column name variations (case-insensitive)
      const getFieldValue = (row, possibleKeys) => {
        // First, try direct key matches
        for (const key of possibleKeys) {
          if (key && row[key] != null && row[key] !== "") {
            const val = String(row[key]).trim();
            if (val) return val;
          }
        }

        // Then, try case-insensitive matching against all row keys
        const rowKeys = Object.keys(row || {});
        for (const key of possibleKeys) {
          if (!key) continue;
          const keyLower = key.toLowerCase().trim();
          for (const rowKey of rowKeys) {
            if (rowKey.toLowerCase().trim() === keyLower) {
              const val = String(row[rowKey]).trim();
              if (val) return val;
            }
          }
        }

        return "";
      };

      // Helper to split "name" field into firstName and lastName
      const splitName = (nameStr) => {
        if (!nameStr || !nameStr.trim()) return { firstName: "", lastName: "" };
        const parts = nameStr.trim().split(/\s+/);
        if (parts.length === 1) return { firstName: parts[0], lastName: "" };
        return { firstName: parts[0], lastName: parts.slice(1).join(" ") };
      };

      const payload = sheetData
        .map((row) => {
          const obj = {};

          // Process email first (required field) - handle multiple column name variations
          const emailValue = getFieldValue(row, ["Email", "email", "EMAIL", "e-mail", "E-mail"]);
          if (!emailValue) {
            return null; // Skip records without email
          }
          obj.email = emailValue.toLowerCase();

          // Process all allowed fields with robust column name matching
          allowedFields.forEach((f) => {
            if (f.key === "email") return; // Already processed

            // Try multiple variations: label, key, lowercase, uppercase, camelCase, etc.
            const possibleKeys = [
              f.label,
              f.key,
              f.label?.toLowerCase(),
              f.label?.toUpperCase(),
              f.key?.toLowerCase(),
              f.key?.toUpperCase(),
              f.key?.charAt(0).toUpperCase() + f.key?.slice(1), // CamelCase
            ];

            const value = getFieldValue(row, possibleKeys);
            if (value) {
              obj[f.key] = value;
            }
          });

          // Handle "name" field - split into firstName and lastName if present
          // Only use "name" if firstName/lastName weren't found in Excel
          const nameValue = getFieldValue(row, ["name", "Name", "NAME", "Full Name", "full name", "FullName", "fullName"]);
          if (nameValue && (!obj.firstName && !obj.lastName)) {
            const { firstName: nameFirst, lastName: nameLast } = splitName(nameValue);
            if (nameFirst) obj.firstName = nameFirst;
            if (nameLast) obj.lastName = nameLast;
          }

          // System fields from Excel are IGNORED (not imported):
          // - _id: MongoDB ObjectId (we match by email, not _id)
          // - mailSentCount: Managed by system (incremented on send)
          // - mailSentHistory: Managed by system (appended on send)
          // - lastMailSentAt: Managed by system (updated on send)
          // - lastMailServiceId: Managed by system (updated on send)
          // These are preserved on update (backend ensures they're never overwritten)

          return obj;
        })
        // Filter out null records (records without email)
        .filter((row) => row !== null && row.email && row.email.trim());

      try {
        // Chunk payload to avoid single huge request (timeout/memory); progress per chunk
        const chunks = [];
        for (let i = 0; i < payload.length; i += UPLOAD_CHUNK_SIZE) {
          chunks.push(payload.slice(i, i + UPLOAD_CHUNK_SIZE));
        }
        const totalChunks = chunks.length;
        let totalInserted = 0;
        let totalModified = 0;

        for (let i = 0; i < chunks.length; i++) {
          const res = await axios.post(
            `${API_ROOT}/sales/postdata`,
            chunks[i],
            authHeaders
          );
          totalInserted += res.data?.inserted ?? 0;
          totalModified += res.data?.modified ?? 0;
          setUploadProgress(Math.round(((i + 1) / totalChunks) * 100));
        }

        alert(
          `Upload successful ✅\nInserted: ${totalInserted}\nUpdated: ${totalModified}`
        );

        fetchSales(currentPage, debouncedSearch, debouncedFilters, undefined, rowsPerPage);
      } catch (err) {
        console.error(err);
        alert("Upload failed");
      } finally {
        setUploading(false);
        setTimeout(() => setUploadProgress(0), 1200);
      }
    };

    file.name.endsWith(".csv")
      ? reader.readAsText(file)
      : reader.readAsBinaryString(file);
  };

  /* ================= EXPORT ================= */
  const exportAll = async () => {
    try {
      // Export ALL data - no filters applied
      const res = await axios.get(
        `${API_ROOT}/sales?exportexcel=true`,
        authHeaders
      );

      if (!res.data?.success || !Array.isArray(res.data.data)) {
        throw new Error("Invalid export data received");
      }

      const data = res.data.data;

      if (data.length === 0) {
        alert("No data to export");
        return;
      }

      // Create workbook and worksheet
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(data);

      // Set column widths for better readability
      const colWidths = [
        { wch: 8 },  // # (sequential number)
        { wch: 15 }, // First Name
        { wch: 15 }, // Last Name
        { wch: 20 }, // Title
        { wch: 30 }, // Company Name
        { wch: 30 }, // Email
        { wch: 18 }, // Corporate Phone
        { wch: 40 }, // Person Linkedin Url
        { wch: 30 }, // Website
        { wch: 40 }, // Company Linkedin Url
        { wch: 40 }, // Facebook Url
        { wch: 40 }, // Twitter Url
      ];
      ws['!cols'] = colWidths;

      // Add worksheet to workbook
      XLSX.utils.book_append_sheet(wb, ws, "Sales Team Data");

      // Generate filename with timestamp
      const timestamp = new Date().toISOString().slice(0, 10).replace(/-/g, '');
      const filename = `Sales_Team_Export_${timestamp}.xlsx`;

      // Write file
      XLSX.writeFile(wb, filename);

      alert(`✅ Export successful!\n\nExported ${data.length} records to ${filename}`);
    } catch (err) {
      console.error("Export error:", err);
      alert(`Export failed: ${err.response?.data?.message || err.message || "Unknown error"}`);
    }
  };

  const exportNameEmail = async () => {
    try {
      // Export ALL data - only name and email
      const res = await axios.get(
        `${API_ROOT}/sales?exportnameemail=true`,
        authHeaders
      );

      if (!res.data?.success || !Array.isArray(res.data.data)) {
        throw new Error("Invalid export data received");
      }

      const data = res.data.data;

      if (data.length === 0) {
        alert("No data to export");
        return;
      }

      // Create workbook and worksheet
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(data);

      // Set column widths
      ws['!cols'] = [
        { wch: 20 }, // First Name
        { wch: 20 }, // Last Name
        { wch: 35 }, // Email
      ];

      // Add worksheet to workbook
      XLSX.utils.book_append_sheet(wb, ws, "Name & Email");

      // Generate filename with timestamp
      const timestamp = new Date().toISOString().slice(0, 10).replace(/-/g, '');
      const filename = `Name_Email_Export_${timestamp}.xlsx`;

      // Write file
      XLSX.writeFile(wb, filename);

      alert(`✅ Export successful!\n\nExported ${data.length} records to ${filename}`);
    } catch (err) {
      console.error("Export error:", err);
      alert(`Export failed: ${err.response?.data?.message || err.message || "Unknown error"}`);
    }
  };

  return (
    <div className="min-h-full">
      <div className="max-w-[1600px] mx-auto">
        {/* Page header */}
        <div className="mb-6 lg:mb-8">
          <h1 className="text-2xl font-bold text-slate-900 tracking-tight">Sales Team Data</h1>
          <p className="mt-1 text-sm text-slate-500">
            Manage leads, send campaigns, and export data. Total records: <span className="font-medium text-slate-700">{totalData}</span>
          </p>
        </div>

        {/* Actions card */}
        <div className="bg-white rounded-xl border border-slate-200/80 shadow-sm p-4 sm:p-5 mb-6">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
            <div className="flex flex-wrap items-center gap-2">
              <button
                type="button"
            onClick={() => {
              fetchMailTemplates();
              fetchMailServices();
              fetchMailSignatures();
              setShowSendMailModal(true);
              fetchSendCapacity(null);
            }}
                disabled={rows.length === 0 && totalData === 0}
                className="inline-flex items-center gap-2 px-4 py-2.5 rounded-lg text-sm font-semibold text-white bg-emerald-600 hover:bg-emerald-700 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" /></svg>
                Send mail
              </button>
              <button
                type="button"
            onClick={() => {
              setShowConfigSidebar(true);
              fetchScheduledCampaigns();
              fetchMailTemplates();
              fetchMailSignatures();
            }}
                className="inline-flex items-center gap-2 px-4 py-2.5 rounded-lg text-sm font-medium text-slate-700 bg-slate-100 hover:bg-slate-200 focus:outline-none focus:ring-2 focus:ring-slate-300 transition-colors"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /></svg>
                Mail config
              </button>
              <label
                className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-lg text-sm font-medium cursor-pointer transition-colors focus-within:ring-2 focus-within:ring-violet-500 focus-within:ring-offset-2 ${
                  uploading ? "bg-slate-200 text-slate-500 cursor-wait" : "bg-violet-600 text-white hover:bg-violet-700"
                }`}
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" /></svg>
                {uploading ? "Uploading…" : "Import Excel / CSV"}
                <input type="file" accept=".xlsx,.xls,.csv" onChange={handleImport} className="hidden" disabled={uploading} />
              </label>
            </div>
          </div>

          {/* Upload progress */}
          {uploading && (
            <div className="mt-4 pt-4 border-t border-slate-100">
              <div className="flex justify-between text-xs text-slate-600 mb-1.5">
                <span>Uploading data</span>
                <span className="font-medium">{uploadProgress}%</span>
              </div>
              <div className="w-full h-1.5 rounded-full bg-slate-200 overflow-hidden">
                <div className="h-full bg-violet-600 rounded-full transition-all duration-300" style={{ width: `${uploadProgress}%` }} />
              </div>
            </div>
          )}
        </div>

        {/* Search & filters */}
        <div className="bg-white rounded-xl border border-slate-200/80 shadow-sm p-4 sm:p-5 mb-6">
          <div className="flex flex-col sm:flex-row gap-3">
            <div className="flex-1 relative">
              <svg className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
              <input
                type="text"
                placeholder="Search by name, company, email, title, or phone..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-full pl-10 pr-10 py-2.5 text-sm border border-slate-200 rounded-lg bg-slate-50/50 focus:bg-white focus:ring-2 focus:ring-emerald-500/30 focus:border-emerald-500 outline-none transition placeholder:text-slate-400"
              />
              {searchQuery && (
                <button type="button" onClick={clearSearch} className="absolute right-3 top-1/2 -translate-y-1/2 p-1 rounded text-slate-400 hover:text-slate-600 hover:bg-slate-100">
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>
                </button>
              )}
            </div>
            <button
              onClick={() => setShowFilters(!showFilters)}
              className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                showFilters || hasActiveFilters
                  ? "bg-violet-600 text-white hover:bg-violet-700"
                  : "bg-slate-100 text-slate-700 hover:bg-slate-200"
              }`}
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" /></svg>
              Filters
              {hasActiveFilters && (
                <span className="bg-white/20 text-xs font-bold px-2 py-0.5 rounded-full">{Object.values(filters).filter((f) => f.trim()).length}</span>
              )}
            </button>
          </div>

          {/* Active filter chips */}
          {(hasActiveFilters || searchQuery) && (
            <div className="flex flex-wrap items-center gap-2 mt-4 pt-4 border-t border-slate-100">
              <span className="text-xs font-medium text-slate-500 uppercase tracking-wider">Active</span>
              {searchQuery && (
                <span className="inline-flex items-center gap-1.5 px-2.5 py-1 bg-violet-50 text-violet-700 rounded-md text-sm">
                  Search: &quot;{searchQuery}&quot;
                  <button type="button" onClick={clearSearch} className="hover:text-violet-900">×</button>
                </span>
              )}
              {filters.company && (
                <span className="inline-flex items-center gap-1.5 px-2.5 py-1 bg-blue-50 text-blue-700 rounded-md text-sm">
                  Company: {filters.company}
                  <button type="button" onClick={() => setFilters({ ...filters, company: "" })} className="hover:text-blue-900">×</button>
                </span>
              )}
              {filters.title && (
                <span className="inline-flex items-center gap-1.5 px-2.5 py-1 bg-emerald-50 text-emerald-700 rounded-md text-sm">
                  Title: {filters.title}
                  <button type="button" onClick={() => setFilters({ ...filters, title: "" })} className="hover:text-emerald-900">×</button>
                </span>
              )}
              {filters.email && (
                <span className="inline-flex items-center gap-1.5 px-2.5 py-1 bg-amber-50 text-amber-700 rounded-md text-sm">
                  Email: {filters.email}
                  <button type="button" onClick={() => setFilters({ ...filters, email: "" })} className="hover:text-amber-900">×</button>
                </span>
              )}
              {filters.contact && (
                <span className="inline-flex items-center gap-1.5 px-2.5 py-1 bg-rose-50 text-rose-700 rounded-md text-sm">
                  Phone: {filters.contact}
                  <button type="button" onClick={() => setFilters({ ...filters, contact: "" })} className="hover:text-rose-900">×</button>
                </span>
              )}
              <button type="button" onClick={() => { clearFilters(); clearSearch(); }} className="text-sm text-slate-500 hover:text-slate-800 underline">
                Clear all
              </button>
            </div>
          )}

          {showFilters && (
            <div className="mt-4 pt-4 border-t border-slate-100">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                {[
                  { key: "company", label: "Company", placeholder: "Filter by company..." },
                  { key: "title", label: "Title", placeholder: "Filter by title..." },
                  { key: "email", label: "Email", placeholder: "Filter by email..." },
                  { key: "contact", label: "Phone", placeholder: "Filter by phone..." },
                ].map(({ key, label, placeholder }) => (
                  <div key={key}>
                    <label className="block text-xs font-medium text-slate-600 mb-1.5">{label}</label>
                    <input
                      type="text"
                      placeholder={placeholder}
                      value={filters[key]}
                      onChange={(e) => setFilters({ ...filters, [key]: e.target.value })}
                      className="w-full px-3 py-2 text-sm border border-slate-200 rounded-lg focus:ring-2 focus:ring-emerald-500/30 focus:border-emerald-500 outline-none"
                    />
                  </div>
                ))}
              </div>
            </div>
          )}

          <div className="mt-3 text-xs text-slate-500">
            Showing {rows.length} of {totalData} records{(hasActiveFilters || debouncedSearch) && " (filtered)"}
          </div>
        </div>

        {/* Table card */}
        <div className="bg-white rounded-xl border border-slate-200/80 shadow-sm overflow-hidden">
          <div className="overflow-x-auto">
            <table className="min-w-full text-sm">
              <thead>
                <tr className="bg-slate-50 border-b border-slate-200">
                  <th className="px-4 py-3 text-left text-xs font-semibold text-slate-600 uppercase tracking-wider w-12">#</th>
                  {allowedFields.map((f) => (
                    <th key={f.key} className="px-4 py-3 text-left text-xs font-semibold text-slate-600 uppercase tracking-wider whitespace-nowrap">{f.label}</th>
                  ))}
                  <th className="px-4 py-3 text-left text-xs font-semibold text-slate-600 uppercase tracking-wider whitespace-nowrap">Mail sent</th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-slate-600 uppercase tracking-wider whitespace-nowrap max-w-[180px]">Topics sent</th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-slate-600 uppercase tracking-wider whitespace-nowrap">Last sent</th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-slate-600 uppercase tracking-wider whitespace-nowrap w-20">History</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100">
                {rows.length ? (
                  rows.map((row, i) => (
                    <tr key={row._id || i} className="hover:bg-slate-50/80 transition-colors">
                      <td className="px-4 py-3 text-slate-500 font-mono text-xs">{row.rowNumber ?? "—"}</td>
                      {allowedFields.map((f) => (
                        <td key={f.key} className="px-4 py-3 text-slate-700 max-w-[200px] truncate">{row[f.key] || "—"}</td>
                      ))}
                      <td className="px-4 py-3 text-slate-700">{row.mailSentCount ?? 0}</td>
                      <td className="px-4 py-3 text-slate-600 max-w-[180px] truncate" title={row.mailSentHistory?.length ? [...new Set(row.mailSentHistory.map((h) => h.topic || h.subject).filter(Boolean))].join(", ") : ""}>
                        {row.mailSentHistory?.length ? [...new Set(row.mailSentHistory.map((h) => h.topic || h.subject).filter(Boolean))].slice(0, 3).join(", ") || "—" : "—"}
                      </td>
                      <td className="px-4 py-3 text-slate-600 whitespace-nowrap">
                        {row.lastMailSentAt ? new Date(row.lastMailSentAt).toLocaleString(undefined, { dateStyle: "short", timeStyle: "short" }) : "—"}
                      </td>
                      <td className="px-4 py-3">
                        <button
                          type="button"
                          onClick={() => setMailHistoryRow(row)}
                          className="text-emerald-600 hover:text-emerald-700 font-medium text-xs"
                          title="View mail history"
                        >
                          View
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={allowedFields.length + 5} className="px-4 py-12 text-center text-slate-400">
                      {hasActiveFilters || debouncedSearch ? "No records match your filters" : "No data available"}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* Pagination & export */}
        {rows.length > 0 && (
          <div className="mt-6 flex flex-wrap items-center justify-between gap-4">
            <div className="flex flex-wrap items-center gap-3">
              {/* Rows per page selector */}
              <div className="flex items-center gap-2">
                <span className="text-sm text-slate-600">Rows per page:</span>
                <select
                  value={rowsPerPage}
                  onChange={(e) => handleRowsPerPageChange(e.target.value)}
                  className="px-2.5 py-2 text-sm border border-slate-200 rounded-lg bg-white focus:ring-2 focus:ring-emerald-500/30 focus:border-emerald-500 outline-none"
                >
                  {ROWS_PER_PAGE_OPTIONS.map((n) => (
                    <option key={n} value={n}>{n}</option>
                  ))}
                </select>
              </div>

              <div className="flex items-center gap-2">
                {/* First */}
                <button
                  type="button"
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage(1)}
                  className="px-3 py-2 rounded-lg text-sm font-medium text-slate-700 bg-white border border-slate-200 hover:bg-slate-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                >
                  First
                </button>

                {/* Previous */}
                <button
                  type="button"
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage((p) => p - 1)}
                  className="px-3 py-2 rounded-lg text-sm font-medium text-slate-700 bg-white border border-slate-200 hover:bg-slate-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                >
                  Previous
                </button>

                {/* Page Info */}
                <span className="px-3 py-2 text-sm text-slate-600">
                  Page {currentPage} of {totalPages}
                </span>

                {/* Next */}
                <button
                  type="button"
                  disabled={currentPage === totalPages}
                  onClick={() => setCurrentPage((p) => p + 1)}
                  className="px-3 py-2 rounded-lg text-sm font-medium text-slate-700 bg-white border border-slate-200 hover:bg-slate-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                >
                  Next
                </button>

                {/* Last */}
                <button
                  type="button"
                  disabled={currentPage === totalPages}
                  onClick={() => setCurrentPage(totalPages)}
                  className="px-3 py-2 rounded-lg text-sm font-medium text-slate-700 bg-white border border-slate-200 hover:bg-slate-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                >
                  Last
                </button>
              </div>
            </div>

            <div className="flex gap-2">
              <button type="button" onClick={exportAll} className="inline-flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 transition-colors">
                Export Excel
              </button>
              <button type="button" onClick={exportNameEmail} className="inline-flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium text-slate-700 bg-slate-100 hover:bg-slate-200 transition-colors">
                Export Name & Email
              </button>
            </div>
          </div>
        )}
      </div>

      {/* Mail configuration sidebar */}
      {showConfigSidebar && (
        <>
          <div className="fixed inset-0 z-40 bg-black/30" onClick={() => setShowConfigSidebar(false)} aria-hidden="true" />
          <aside className="fixed top-0 right-0 z-50 w-full max-w-md h-full bg-white shadow-xl overflow-y-auto flex flex-col">
            <div className="sticky top-0 bg-white border-b px-4 py-3 flex items-center justify-between">
              <h2 className="text-lg font-semibold text-gray-900">Mail configuration</h2>
              <button type="button" onClick={() => setShowConfigSidebar(false)} className="p-2 rounded-lg hover:bg-gray-100 text-gray-600">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>
              </button>
            </div>
            <div className="p-4 space-y-6">
              {/* Suggested defaults (best options) */}
              <div className="rounded-lg border border-purple-200 bg-purple-50 p-3">
                <h3 className="text-sm font-semibold text-purple-900 mb-2">Suggested max mail (best options)</h3>
                <ul className="text-xs text-purple-800 space-y-1">
                  <li>• {MAIL_CONFIG_DEFAULTS.gmail}</li>
                  <li>• {MAIL_CONFIG_DEFAULTS.office365}</li>
                  <li>• {MAIL_CONFIG_DEFAULTS.custom}</li>
                </ul>
              </div>

              {/* Email accounts */}
              <div>
                <div className="flex items-center justify-between mb-2">
                  <h3 className="text-sm font-semibold text-gray-900">Email accounts</h3>
                  <button type="button" onClick={openAddMailService} className="text-sm text-purple-600 hover:underline">+ Add</button>
                </div>
                {mailServices.length === 0 ? (
                  <p className="text-sm text-gray-500">No accounts. Add one to send campaigns.</p>
                ) : (
                  <ul className="space-y-2">
                    {mailServices.map((s) => (
                      <li key={s._id} className="flex items-center justify-between text-sm border rounded-lg px-3 py-2 bg-gray-50">
                        <span className="font-medium">{s.name}</span>
                        <span className="text-gray-500">{s.maxPerWindow}/{s.windowMinutes}m</span>
                        <span className="flex gap-1">
                          <button type="button" onClick={() => openEditMailService(s)} className="text-blue-600 hover:underline">Edit</button>
                          <button type="button" onClick={() => deleteMailService(s._id)} className="text-red-600 hover:underline">Del</button>
                        </span>
                      </li>
                    ))}
                  </ul>
                )}
              </div>

              {/* Templates (placeholders from sales data) */}
              <div>
                <div className="flex items-center justify-between mb-2">
                  <h3 className="text-sm font-semibold text-gray-900">Templates</h3>
                  <button type="button" onClick={openAddTemplate} className="text-sm text-purple-600 hover:underline">+ Add</button>
                </div>
                <p className="text-xs text-gray-500 mb-2">Use {PLACEHOLDER_EXAMPLE}, {PLACEHOLDER_COMPANY}, etc. in subject/body; replaced per contact.</p>
                {mailTemplates.length === 0 ? (
                  <p className="text-sm text-gray-500">No templates. Add one to use in Send mail.</p>
                ) : (
                  <ul className="space-y-2">
                    {mailTemplates.map((t) => (
                      <li key={t._id} className="flex items-center justify-between text-sm border rounded-lg px-3 py-2 bg-gray-50">
                        <span className="font-medium truncate flex-1" title={t.subject}>{t.name}</span>
                        <span className="flex gap-1 shrink-0">
                          <button type="button" onClick={() => openEditTemplate(t)} className="text-blue-600 hover:underline">Edit</button>
                          <button type="button" onClick={() => deleteTemplate(t._id)} className="text-red-600 hover:underline">Del</button>
                        </span>
                      </li>
                    ))}
                  </ul>
                )}
              </div>

              {/* Signatures (HTML + logo, appended to emails) */}
              <div>
                <div className="flex items-center justify-between mb-2">
                  <h3 className="text-sm font-semibold text-gray-900">Signatures</h3>
                  <button type="button" onClick={openAddSignature} className="text-sm text-purple-600 hover:underline">+ Add</button>
                </div>
                <p className="text-xs text-gray-500 mb-2">HTML content (logo, name, etc.) appended to each email. Select in Send mail.</p>
                {mailSignatures.length === 0 ? (
                  <p className="text-sm text-gray-500">No signatures. Add one to use in Send mail.</p>
                ) : (
                  <ul className="space-y-2">
                    {mailSignatures.map((s) => (
                      <li key={s._id} className="flex items-center justify-between text-sm border rounded-lg px-3 py-2 bg-gray-50">
                        <span className="font-medium truncate flex-1">{s.name}{s.isDefault ? " (default)" : ""}</span>
                        <span className="flex gap-1 shrink-0">
                          <button type="button" onClick={() => openEditSignature(s)} className="text-blue-600 hover:underline">Edit</button>
                          <button type="button" onClick={() => deleteSignature(s._id)} className="text-red-600 hover:underline">Del</button>
                        </span>
                      </li>
                    ))}
                  </ul>
                )}
              </div>

              {/* Scheduled campaigns */}
              <div>
                <h3 className="text-sm font-semibold text-gray-900 mb-2">Scheduled campaigns</h3>
                {scheduledCampaigns.filter((c) => c.status === "pending").length === 0 ? (
                  <p className="text-sm text-gray-500">No pending scheduled campaigns.</p>
                ) : (
                  <ul className="space-y-2">
                    {scheduledCampaigns.filter((c) => c.status === "pending").map((c) => (
                      <li key={c._id} className="text-sm border rounded-lg px-3 py-2 bg-amber-50 flex items-center justify-between gap-2">
                        <div className="truncate flex-1 min-w-0">
                          {c.topic && <span className="font-medium text-amber-800">{c.topic}</span>}
                          <span className="truncate block text-gray-700" title={c.subject}>{c.subject}</span>
                        </div>
                        <span className="text-gray-500 text-xs whitespace-nowrap shrink-0">
                          {new Date(c.sendAt).toLocaleString(undefined, { dateStyle: "short", timeStyle: "short" })}
                        </span>
                        <button type="button" onClick={() => cancelScheduledCampaign(c._id)} className="text-red-600 hover:underline shrink-0">Cancel</button>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
          </aside>
        </>
      )}

      {/* Mail service add/edit modal */}
      {showMailServiceModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
          <div className="bg-white rounded-xl shadow-lg max-w-lg w-full max-h-[90vh] overflow-y-auto p-6">
            <h3 className="text-lg font-semibold mb-4">{editingMailService ? "Edit email account" : "Add email account"}</h3>
            <div className="space-y-3">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Name</label>
                <input
                  type="text"
                  value={mailServiceForm.name}
                  onChange={(e) => setMailServiceForm({ ...mailServiceForm, name: e.target.value })}
                  placeholder="e.g. Gmail Main"
                  className="w-full px-3 py-2 border rounded-md"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Type</label>
                <select
                  value={mailServiceForm.type}
                  onChange={(e) => {
                    const t = e.target.value;
                    setMailServiceForm({
                      ...mailServiceForm,
                      type: t,
                      configKey: t === "gmail" ? "EMAIL_USER" : t === "office365" ? "OFFICE365_USER" : mailServiceForm.configKey,
                    });
                  }}
                  className="w-full px-3 py-2 border rounded-md"
                >
                  <option value="gmail">Gmail (use env EMAIL_USER)</option>
                  <option value="office365">Office 365 (use env OFFICE365_USER)</option>
                  <option value="custom">Custom SMTP</option>
                </select>
              </div>
              {(mailServiceForm.type === "gmail" || mailServiceForm.type === "office365") && (
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Config key (from .env)</label>
                  <select
                    value={mailServiceForm.type === "gmail" ? (mailServiceForm.configKey || "EMAIL_USER") : (mailServiceForm.configKey || "OFFICE365_USER")}
                    onChange={(e) => setMailServiceForm({ ...mailServiceForm, configKey: e.target.value })}
                    className="w-full px-3 py-2 border rounded-md"
                  >
                    {mailServiceForm.type === "gmail" && <option value="EMAIL_USER">EMAIL_USER (Gmail)</option>}
                    {mailServiceForm.type === "office365" && <option value="OFFICE365_USER">OFFICE365_USER (Office 365)</option>}
                  </select>
                </div>
              )}
              {mailServiceForm.type === "custom" && (
                <>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">SMTP user</label>
                    <input type="text" value={mailServiceForm.user} onChange={(e) => setMailServiceForm({ ...mailServiceForm, user: e.target.value })} className="w-full px-3 py-2 border rounded-md" />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">SMTP password</label>
                    <input type="password" value={mailServiceForm.pass} onChange={(e) => setMailServiceForm({ ...mailServiceForm, pass: e.target.value })} placeholder={editingMailService ? "Leave blank to keep" : ""} className="w-full px-3 py-2 border rounded-md" />
                  </div>
                  <div className="grid grid-cols-2 gap-2">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Host</label>
                      <input type="text" value={mailServiceForm.host} onChange={(e) => setMailServiceForm({ ...mailServiceForm, host: e.target.value })} className="w-full px-3 py-2 border rounded-md" />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Port</label>
                      <input type="number" value={mailServiceForm.port} onChange={(e) => setMailServiceForm({ ...mailServiceForm, port: Number(e.target.value) || 587 })} className="w-full px-3 py-2 border rounded-md" />
                    </div>
                  </div>
                </>
              )}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Suggested preset (rate limit)</label>
                <select
                  className="w-full px-3 py-2 border rounded-md"
                  onChange={(e) => {
                    const idx = Number(e.target.value);
                    if (idx >= 0 && MAIL_SERVICE_PRESETS[idx]) {
                      const p = MAIL_SERVICE_PRESETS[idx];
                      setMailServiceForm((f) => ({ ...f, maxPerWindow: p.maxPerWindow, windowMinutes: p.windowMinutes, delayBetweenEmailsMs: p.delayBetweenEmailsMs }));
                    }
                  }}
                >
                  <option value="">Choose a preset…</option>
                  {MAIL_SERVICE_PRESETS.map((p, idx) => (
                    <option key={idx} value={idx}>{p.label}</option>
                  ))}
                </select>
              </div>
              <div className="grid grid-cols-3 gap-2">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Max per window</label>
                  <input type="number" min={1} value={mailServiceForm.maxPerWindow} onChange={(e) => setMailServiceForm({ ...mailServiceForm, maxPerWindow: Number(e.target.value) || 1 })} className="w-full px-3 py-2 border rounded-md" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Window (min)</label>
                  <input type="number" min={1} value={mailServiceForm.windowMinutes} onChange={(e) => setMailServiceForm({ ...mailServiceForm, windowMinutes: Number(e.target.value) || 1 })} className="w-full px-3 py-2 border rounded-md" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Delay (ms)</label>
                  <input type="number" min={0} value={mailServiceForm.delayBetweenEmailsMs} onChange={(e) => setMailServiceForm({ ...mailServiceForm, delayBetweenEmailsMs: Number(e.target.value) || 0 })} className="w-full px-3 py-2 border rounded-md" />
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Max per 24h (optional – policy limit)</label>
                <input
                  type="number"
                  min={1}
                  placeholder="Leave empty to derive from window"
                  value={mailServiceForm.maxPer24h === "" ? "" : mailServiceForm.maxPer24h}
                  onChange={(e) => setMailServiceForm({ ...mailServiceForm, maxPer24h: e.target.value === "" ? "" : Number(e.target.value) || "" })}
                  className="w-full px-3 py-2 border rounded-md"
                />
                <p className="text-xs text-gray-500 mt-0.5">Stored in DB (universal). Used for send capacity and 24h limit. If empty, derived from window.</p>
              </div>
              <div className="flex items-center gap-2">
                <input type="checkbox" id="ms-active" checked={mailServiceForm.isActive} onChange={(e) => setMailServiceForm({ ...mailServiceForm, isActive: e.target.checked })} />
                <label htmlFor="ms-active">Active</label>
              </div>
            </div>
            <div className="flex justify-end gap-2 mt-6">
              <button type="button" onClick={() => setShowMailServiceModal(false)} className="px-4 py-2 rounded bg-gray-100 hover:bg-gray-200">Cancel</button>
              <button type="button" onClick={saveMailService} className="px-4 py-2 rounded bg-purple-600 text-white hover:bg-purple-700">Save</button>
            </div>
          </div>
        </div>
      )}

      {/* Template add/edit modal – body + html preserved exactly for format */}
      {showTemplateModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
          <div className="bg-white rounded-xl shadow-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto p-6">
            <h3 className="text-lg font-semibold mb-4">{editingTemplate ? "Edit template" : "Add template"}</h3>
            <p className="text-xs text-gray-600 mb-3">Placeholders (replaced per contact from sales data): {TEMPLATE_PLACEHOLDERS}</p>
            <div className="space-y-3">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Name</label>
                <input
                  type="text"
                  value={templateForm.name}
                  onChange={(e) => setTemplateForm({ ...templateForm, name: e.target.value })}
                  placeholder="e.g. Welcome email"
                  className="w-full px-3 py-2 border rounded-md"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Subject</label>
                <input
                  type="text"
                  value={templateForm.subject}
                  onChange={(e) => setTemplateForm({ ...templateForm, subject: e.target.value })}
                  placeholder="e.g. Hi {{firstName}}, from {{company}}"
                  className="w-full px-3 py-2 border rounded-md"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Body (plain text)</label>
                <textarea
                  value={templateForm.body}
                  onChange={(e) => setTemplateForm({ ...templateForm, body: e.target.value })}
                  placeholder="e.g. Dear {{name}}, ..."
                  rows={5}
                  className="w-full px-3 py-2 border rounded-md font-mono text-sm resize-y"
                  spellCheck="false"
                />
                <p className="text-xs text-gray-500 mt-0.5">Plain text version. Stored and sent as-is.</p>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">HTML (formatted)</label>
                <textarea
                  value={templateForm.html}
                  onChange={(e) => setTemplateForm({ ...templateForm, html: e.target.value })}
                  placeholder="e.g. <p>Dear {{firstName}},</p><p>...</p>"
                  rows={8}
                  className="w-full px-3 py-2 border rounded-md font-mono text-sm resize-y"
                  spellCheck="false"
                />
                <p className="text-xs text-gray-500 mt-0.5">HTML content for formatted emails. Loaded and saved exactly as entered.</p>
              </div>
            </div>
            <div className="flex justify-end gap-2 mt-6">
              <button type="button" onClick={() => setShowTemplateModal(false)} className="px-4 py-2 rounded bg-gray-100 hover:bg-gray-200">Cancel</button>
              <button type="button" onClick={saveTemplate} className="px-4 py-2 rounded bg-purple-600 text-white hover:bg-purple-700">Save</button>
            </div>
          </div>
        </div>
      )}

      {/* Signature add/edit modal */}
      {showSignatureModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
          <div className="bg-white rounded-xl shadow-lg max-w-lg w-full max-h-[90vh] overflow-y-auto p-6">
            <h3 className="text-lg font-semibold mb-4">{editingSignature ? "Edit signature" : "Add signature"}</h3>
            <p className="text-xs text-gray-600 mb-3">HTML content is appended to each email. Use &lt;img src=&quot;...&quot;&gt; for logo.</p>
            <div className="space-y-3">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Name</label>
                <input
                  type="text"
                  value={signatureForm.name}
                  onChange={(e) => setSignatureForm({ ...signatureForm, name: e.target.value })}
                  placeholder="e.g. Company default"
                  className="w-full px-3 py-2 border rounded-md"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Logo URL (optional)</label>
                <input
                  type="url"
                  value={signatureForm.logoUrl}
                  onChange={(e) => setSignatureForm({ ...signatureForm, logoUrl: e.target.value })}
                  placeholder="https://example.com/logo.png"
                  className="w-full px-3 py-2 border rounded-md"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Content (HTML)</label>
                <textarea
                  value={signatureForm.content}
                  onChange={(e) => setSignatureForm({ ...signatureForm, content: e.target.value })}
                  placeholder={'e.g. <p>Best regards,<br/>John</p> or <img src="..." alt="Logo"/>'}
                  rows={6}
                  className="w-full px-3 py-2 border rounded-md font-mono text-sm"
                />
              </div>
              <div className="flex items-center gap-2">
                <input
                  type="checkbox"
                  id="sig-default"
                  checked={signatureForm.isDefault}
                  onChange={(e) => setSignatureForm({ ...signatureForm, isDefault: e.target.checked })}
                />
                <label htmlFor="sig-default">Default signature</label>
              </div>
            </div>
            <div className="flex justify-end gap-2 mt-6">
              <button type="button" onClick={() => setShowSignatureModal(false)} className="px-4 py-2 rounded bg-gray-100 hover:bg-gray-200">Cancel</button>
              <button type="button" onClick={saveSignature} className="px-4 py-2 rounded bg-purple-600 text-white hover:bg-purple-700">Save</button>
            </div>
          </div>
        </div>
      )}

      {/* Send mail modal – pro layout: template, services, recipients (printer-style), test, content, when */}
      {showSendMailModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
          <div className="bg-white rounded-2xl shadow-xl max-w-2xl w-full max-h-[90vh] overflow-hidden flex flex-col">
            <div className="px-6 py-4 border-b bg-gradient-to-r from-emerald-600 to-emerald-700 text-white">
              <h3 className="text-lg font-semibold">Send mail to contacts</h3>
              <p className="text-sm text-emerald-100 mt-0.5">Choose template, services, recipients (like printer: 1-34, 3, 4), and optionally send a test.</p>
            </div>
            <div className="p-6 overflow-y-auto flex-1 space-y-5">
              {/* Row 1: Template + Services side by side */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="rounded-xl border border-gray-200 bg-gray-50/50 p-4">
                  <label className="block text-sm font-semibold text-gray-800 mb-2">1. Template</label>
                  <select
                    value={sendMailForm.templateId}
                    onChange={(e) => {
                      const id = e.target.value;
                      const t = mailTemplates.find((x) => x._id === id);
                      setSendMailForm({
                        ...sendMailForm,
                        templateId: id,
                        subject: t ? (t.subject ?? "") : sendMailForm.subject,
                        body: t ? (t.body ?? "") : sendMailForm.body,
                        html: t ? (t.html ?? "") : sendMailForm.html,
                        topic: sendMailForm.topic || (t ? t.name : ""),
                      });
                    }}
                    className="w-full px-3 py-2.5 border border-gray-300 rounded-lg bg-white text-sm"
                  >
                    <option value="">None – type subject & body below</option>
                    {mailTemplates.map((t) => (
                      <option key={t._id} value={t._id}>{t.name}</option>
                    ))}
                  </select>
                </div>
                <div className="rounded-xl border border-gray-200 bg-gray-50/50 p-4 md:col-span-2">
                  <label className="block text-sm font-semibold text-gray-800 mb-2">Signature <span className="text-red-600">* required</span></label>
                  <select
                    value={sendMailForm.signatureId}
                    onChange={(e) => setSendMailForm({ ...sendMailForm, signatureId: e.target.value })}
                    className="w-full px-3 py-2.5 border border-gray-300 rounded-lg bg-white text-sm"
                    aria-required="true"
                  >
                    <option value="">Select a signature…</option>
                    {mailSignatures.map((s) => (
                      <option key={s._id} value={s._id}>{s.name}{s.isDefault ? " (default)" : ""}</option>
                    ))}
                  </select>
                  <p className="text-xs text-gray-500 mt-1">Appended to each email (HTML + logo). Add in Mail config.</p>
                </div>
                <div className="rounded-xl border border-gray-200 bg-gray-50/50 p-4">
                  <label className="block text-sm font-semibold text-gray-800 mb-2">2. Mail services</label>
                  <div className="border border-gray-200 rounded-lg p-2 bg-white max-h-28 overflow-y-auto space-y-1.5">
                    {mailServices.filter((s) => s.isActive).length === 0 ? (
                      <p className="text-xs text-gray-500">No active accounts. Add in Mail config.</p>
                    ) : (
                      (() => {
                        const activeIds = mailServices.filter((x) => x.isActive).map((x) => x._id);
                        const useAll = sendMailForm.serviceIds.length === 0;
                        return mailServices.filter((s) => s.isActive).map((s) => (
                          <label key={s._id} className="flex items-center gap-2 cursor-pointer text-sm">
                            <input
                              type="checkbox"
                              checked={useAll || sendMailForm.serviceIds.includes(s._id)}
                              onChange={(e) => {
                                const checked = e.target.checked;
                                const current = useAll ? activeIds : sendMailForm.serviceIds;
                                let next = checked
                                  ? (current.includes(s._id) ? current : [...current, s._id])
                                  : current.filter((id) => id !== s._id);
                                if (next.length === activeIds.length) next = [];
                                setSendMailForm({ ...sendMailForm, serviceIds: next });
                                fetchSendCapacity(next.length ? next : null);
                              }}
                              className="rounded border-gray-300"
                            />
                            <span className="font-medium truncate">{s.name}</span>
                            <span className="text-gray-500 text-xs truncate max-w-[100px]" title={s.user}>{s.user || "—"}</span>
                          </label>
                        ));
                      })()
                    )}
                  </div>
                </div>
              </div>

              {/* Send capacity (24h policy) – per account + total recommended */}
              {mailServices.filter((s) => s.isActive).length > 0 && (
                <div className="rounded-xl border border-slate-200 bg-slate-50/80 p-4">
                  <div className="flex items-center justify-between gap-2 mb-2">
                    <label className="block text-sm font-semibold text-slate-800">Send capacity (24h policy)</label>
                    {sendCapacityLoading && <span className="text-xs text-slate-500">Updating…</span>}
                  </div>
                  <p className="text-xs text-slate-600 mb-3">
                    Per-account limits are stored in the database (universal). When you send, the backend distributes emails randomly across selected accounts.
                  </p>
                  {sendCapacity.services.length > 0 ? (
                    <>
                      <div className="overflow-x-auto border border-slate-200 rounded-lg bg-white">
                        <table className="min-w-full text-xs">
                          <thead>
                            <tr className="bg-slate-100 border-b border-slate-200">
                              <th className="px-3 py-2 text-left font-semibold text-slate-700">Account</th>
                              <th className="px-3 py-2 text-right font-semibold text-slate-700">Limit (24h)</th>
                              <th className="px-3 py-2 text-right font-semibold text-slate-700">Sent (24h)</th>
                              <th className="px-3 py-2 text-right font-semibold text-slate-700">Available</th>
                              <th className="px-3 py-2 text-right font-semibold text-slate-700">Recommended</th>
                            </tr>
                          </thead>
                          <tbody>
                            {sendCapacity.services.map((svc) => (
                              <tr key={svc._id} className="border-b border-slate-100 last:border-0">
                                <td className="px-3 py-2 font-medium text-slate-800">{svc.name}</td>
                                <td className="px-3 py-2 text-right text-slate-600">{svc.limit24h}</td>
                                <td className="px-3 py-2 text-right text-slate-600">{svc.sent24h}</td>
                                <td className="px-3 py-2 text-right text-slate-700">{svc.available24h}</td>
                                <td className="px-3 py-2 text-right font-medium text-emerald-700">{svc.recommended24h}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      <div className="mt-3 flex flex-wrap items-center gap-2">
                        <span className="inline-flex items-center px-2.5 py-1 rounded-lg bg-emerald-100 text-emerald-800 text-sm font-semibold">
                          Total recommended: {sendCapacity.totalRecommended.toLocaleString()} emails
                        </span>
                        {sendMailSelectedCount > sendCapacity.totalRecommended && sendCapacity.totalRecommended > 0 && (
                          <span className="text-amber-700 text-xs">
                            You selected {sendMailSelectedCount} contacts; only {sendCapacity.totalRecommended} can be sent in 24h with current capacity. Backend will send up to the limit.
                          </span>
                        )}
                      </div>
                    </>
                  ) : (
                    <p className="text-xs text-slate-500">No capacity data. Add active mail accounts in Mail config.</p>
                  )}
                </div>
              )}

              {/* 3. Recipients – page, select rows (1-N on page or first N from filter), or all filter */}
              <div className="rounded-xl border border-gray-200 bg-gray-50/50 p-4">
                <label className="block text-sm font-semibold text-gray-800 mb-2">3. Recipients</label>
                <div className="space-y-3">
                  <div className="flex flex-wrap gap-3 items-center">
                    <label className="inline-flex items-center gap-2 cursor-pointer">
                      <input type="radio" name="sendTo" checked={sendMailForm.sendTo === "page"} onChange={() => setSendMailForm({ ...sendMailForm, sendTo: "page", rowSelection: "" })} className="text-emerald-600" />
                      <span className="text-sm">Current page (all {rows.length})</span>
                    </label>
                    <label className="inline-flex items-center gap-2 cursor-pointer">
                      <input type="radio" name="sendTo" checked={sendMailForm.sendTo === "pageSelection"} onChange={() => setSendMailForm({ ...sendMailForm, sendTo: "pageSelection" })} className="text-emerald-600" />
                      <span className="text-sm">Select rows (printer-style: 1-34, 3, 4)</span>
                    </label>
                    <label className="inline-flex items-center gap-2 cursor-pointer">
                      <input type="radio" name="sendTo" checked={sendMailForm.sendTo === "filter"} onChange={() => setSendMailForm({ ...sendMailForm, sendTo: "filter", rowSelection: "" })} className="text-emerald-600" />
                      <span className="text-sm">All matching filter ({totalData.toLocaleString()})</span>
                    </label>
                  </div>
                  {sendMailForm.sendTo === "pageSelection" && (
                    <>
                      <input
                        type="text"
                        value={sendMailForm.rowSelection}
                        onChange={(e) => setSendMailForm({ ...sendMailForm, rowSelection: e.target.value })}
                        placeholder="e.g. 1-34, 3, 4 (ranges and single rows)"
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm font-mono"
                      />
                      <p className="text-xs text-gray-500">
                        Printer-style: ranges (1-34) and single rows (3, 4). Uses row numbers (counter from Excel upload). Max {totalData.toLocaleString()} (capped at 50,000).
                      </p>
                    </>
                  )}
                  <div className="flex flex-wrap items-center gap-2 text-sm font-medium text-gray-700">
                    <span className="inline-flex items-center px-2.5 py-1 rounded-full bg-emerald-100 text-emerald-800">
                      {sendMailSelectedCount.toLocaleString()} contact{sendMailSelectedCount !== 1 ? "s" : ""} selected
                      {parsedRowSelection.isBeyondPage && parsedRowSelection.minRowNumber > 0 && parsedRowSelection.maxRowNumber > 0 && (
                        <span className="ml-1 font-normal">(row numbers {parsedRowSelection.minRowNumber}–{parsedRowSelection.maxRowNumber} from filter)</span>
                      )}
                    </span>
                    {sendMailSelectedRows && sendMailSelectedRows.length > 0 && sendMailSelectedRows.length <= 20 && !parsedRowSelection.isBeyondPage && (
                      <span className="text-gray-500 truncate" title={sendMailSelectedRows.map((r) => r.email).join(", ")}>
                        {sendMailSelectedRows.map((r) => r.email).join(", ")}
                      </span>
                    )}
                    {sendMailSelectedRows && sendMailSelectedRows.length > 20 && !parsedRowSelection.isBeyondPage && (
                      <span className="text-gray-500">First: {sendMailSelectedRows.slice(0, 3).map((r) => r.email).join(", ")} …</span>
                    )}
                  </div>
                </div>
              </div>

              {/* Test email */}
              <div className="rounded-xl border border-amber-200 bg-amber-50/50 p-4">
                <label className="block text-sm font-semibold text-gray-800 mb-2">Send test email</label>
                <div className="flex flex-wrap gap-2 items-end">
                  <div className="flex-1 min-w-[200px]">
                    <input
                      type="email"
                      value={testEmail}
                      onChange={(e) => setTestEmail(e.target.value)}
                      placeholder="your@email.com"
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm"
                    />
                  </div>
                  <button
                    type="button"
                    onClick={runSendTestEmail}
                  disabled={
                    sendingTest ||
                    !(sendMailForm.subject ?? "").trim() ||
                    (!((sendMailForm.body ?? "").trim()) && !((sendMailForm.html ?? "").trim())) ||
                    !(sendMailForm.signatureId ?? "").trim()
                  }
                    className="px-4 py-2 rounded-lg bg-amber-500 text-white font-medium text-sm hover:bg-amber-600 disabled:opacity-50"
                  >
                    {sendingTest ? "Sending…" : "Send test"}
                  </button>
                </div>
                <p className="text-xs text-gray-600 mt-1">Uses current template/subject/body and selected services. No contact history.</p>
              </div>

              {/* Topic + Subject + Body (+ HTML) – editable even when template selected; optional Save to template */}
              <div className="rounded-xl border border-gray-200 p-4 space-y-3">
                <div className="flex items-center justify-between gap-2 flex-wrap">
                  <label className="block text-sm font-semibold text-gray-800">Content</label>
                  {sendMailForm.templateId && (
                    <button
                      type="button"
                      onClick={saveTemplateFromSendModal}
                      className="text-xs font-medium text-emerald-600 hover:text-emerald-700 hover:underline"
                    >
                      Save current content to template
                    </button>
                  )}
                </div>
                <p className="text-xs text-gray-500">
                  You can edit subject and body (and HTML) here; changes apply to this send. Use &quot;Save current content to template&quot; to update the template for future use.
                </p>
                <input
                  type="text"
                  value={sendMailForm.topic}
                  onChange={(e) => setSendMailForm({ ...sendMailForm, topic: e.target.value })}
                  placeholder="Campaign topic (optional, e.g. RPA Intro)"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm"
                />
                <input
                  type="text"
                  value={sendMailForm.subject}
                  onChange={(e) => setSendMailForm({ ...sendMailForm, subject: e.target.value })}
                  placeholder="Subject (e.g. Hi {{firstName}})"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm"
                />
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">
                    Body (plain text) <span className="text-amber-600">* required if HTML is empty</span>
                  </label>
                  <textarea
                  value={sendMailForm.body}
                    onChange={(e) => setSendMailForm({ ...sendMailForm, body: e.target.value })}
                    placeholder="Body (e.g. Dear {{name}}, …)"
                    rows={3}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm resize-y"
                    aria-required="true"
                  />
                </div>
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">Body (HTML, optional)</label>
                  <textarea
                    value={sendMailForm.html}
                    onChange={(e) => setSendMailForm({ ...sendMailForm, html: e.target.value })}
                    placeholder="e.g. <p>Dear {{firstName}},</p><p>…</p>"
                    rows={3}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm font-mono resize-y"
                    spellCheck="false"
                  />
                </div>
              </div>

              {/* Content with signature – preview as recipients will see */}
              <div className="rounded-xl border border-emerald-200 bg-emerald-50/50 p-4">
                <label className="block text-sm font-semibold text-gray-800 mb-2">Content with signature (preview)</label>
                <p className="text-xs text-gray-600 mb-3">Subject + body (plain/HTML) with the selected signature appended.</p>
                <div className="rounded-lg border border-gray-200 bg-white p-4 text-left space-y-3 min-h-[120px]">
                  {sendMailForm.subject && (
                    <div>
                      <span className="text-xs font-medium text-gray-500 uppercase">Subject</span>
                      <p className="text-sm font-medium text-gray-800 mt-0.5">{sendMailForm.subject}</p>
                    </div>
                  )}

                  {(sendMailForm.body || sendMailForm.templateId) && (
                    <div>
                      <span className="text-xs font-medium text-gray-500 uppercase">Body (plain)</span>
                      <pre className="mt-0.5 text-sm text-gray-700 whitespace-pre-wrap font-sans break-words">
                        {sendMailForm.body || "(from template)"}
                      </pre>
                    </div>
                  )}

                  {(() => {
                    const sel = mailSignatures.find((s) => s._id === sendMailForm.signatureId);
                    const sigHtml = sel ? (sel.content || "").replace(/\{\{logoUrl\}\}/gi, sel.logoUrl || "") : "";
                    const htmlContent = (sendMailForm.html || "").trim();
                    const combinedHtml = htmlContent
                      ? `${htmlContent}${sigHtml ? `<div style="margin-top:1em;border-top:1px solid #eee;padding-top:0.75em;">${sigHtml}</div>` : ""}`
                      : sigHtml;

                    return (
                      <>
                        {htmlContent && (
                          <div>
                            <span className="text-xs font-medium text-gray-500 uppercase">Body (HTML)</span>
                            <div
                              className="mt-1 prose prose-sm max-w-none"
                              dangerouslySetInnerHTML={{ __html: combinedHtml }}
                            />
                          </div>
                        )}
                        {!htmlContent && sigHtml && (
                          <div className="border-t border-gray-200 pt-3 mt-3">
                            <span className="text-xs font-medium text-gray-500 uppercase">Signature (appended)</span>
                            <div className="mt-1 prose prose-sm max-w-none" dangerouslySetInnerHTML={{ __html: sigHtml }} />
                          </div>
                        )}
                      </>
                    );
                  })()}

                  {!sendMailForm.subject &&
                    !sendMailForm.body &&
                    !sendMailForm.templateId &&
                    !sendMailForm.signatureId &&
                    !(sendMailForm.html || "").trim() && (
                      <p className="text-sm text-gray-400">
                        Choose a template or enter subject/body (and optional HTML) and a signature to see preview.
                      </p>
                    )}
                </div>
              </div>

              {/* When */}
              <div className="rounded-xl border border-gray-200 p-4">
                <label className="block text-sm font-semibold text-gray-800 mb-2">When</label>
                <select
                  value={sendMailForm.when}
                  onChange={(e) => {
                    const when = e.target.value;
                    setSendMailForm({
                      ...sendMailForm,
                      when,
                      scheduleDate: when === "schedule" && !sendMailForm.scheduleDate ? getTomorrowDate() : sendMailForm.scheduleDate,
                      scheduleTime: sendMailForm.scheduleTime || "09:00",
                      timezone: sendMailForm.timezone || "Asia/Kolkata",
                    });
                  }}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm"
                >
                  <option value="now">Send now</option>
                  <option value="schedule">Schedule for later</option>
                </select>
                {sendMailForm.when === "schedule" && (
                  <div className="grid grid-cols-3 gap-3 mt-3">
                    <div>
                      <label className="block text-xs font-medium text-gray-600 mb-1">Date</label>
                      <input type="date" value={sendMailForm.scheduleDate || getTomorrowDate()} onChange={(e) => setSendMailForm({ ...sendMailForm, scheduleDate: e.target.value })} min={new Date().toISOString().slice(0, 10)} className="w-full px-3 py-2 border rounded-lg text-sm" />
                    </div>
                    <div>
                      <label className="block text-xs font-medium text-gray-600 mb-1">Time</label>
                      <input type="time" value={sendMailForm.scheduleTime} onChange={(e) => setSendMailForm({ ...sendMailForm, scheduleTime: e.target.value })} className="w-full px-3 py-2 border rounded-lg text-sm" />
                    </div>
                    <div>
                      <label className="block text-xs font-medium text-gray-600 mb-1">Timezone</label>
                      <select value={sendMailForm.timezone} onChange={(e) => setSendMailForm({ ...sendMailForm, timezone: e.target.value })} className="w-full px-3 py-2 border rounded-lg text-sm">
                        {TIMEZONE_OPTIONS.map((o) => (
                          <option key={o.value} value={o.value}>{o.label}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="px-6 py-4 border-t bg-gray-50 flex flex-wrap items-center justify-between gap-3">
              <div className="flex items-center gap-2">
                {campaignToken && campaignStatus?.status === "sending" && (
                  <span className="text-sm text-slate-600">
                    Sending… {campaignStatus.sent + campaignStatus.failed} / {campaignStatus.total}
                  </span>
                )}
                {campaignToken && campaignStatus?.status === "sending" && (
                  <button
                    type="button"
                    onClick={stopCurrentCampaign}
                    className="px-3 py-2 rounded-lg bg-red-100 text-red-700 font-medium hover:bg-red-200 text-sm"
                  >
                    Stop sending
                  </button>
                )}
              </div>
              <div className="flex gap-3">
                <button type="button" onClick={() => setShowSendMailModal(false)} disabled={sendingMail} className="px-4 py-2.5 rounded-lg bg-gray-200 text-gray-800 font-medium hover:bg-gray-300 disabled:opacity-50">Cancel</button>
                <button
                  type="button"
                  onClick={runSendCampaign}
                  disabled={
                    sendingMail ||
                    !(sendMailForm.subject ?? "").trim() ||
                    (!((sendMailForm.body ?? "").trim()) && !((sendMailForm.html ?? "").trim())) ||
                    !(sendMailForm.signatureId ?? "").trim()
                  }
                  className="px-5 py-2.5 rounded-lg bg-emerald-600 text-white font-medium hover:bg-emerald-700 disabled:opacity-50"
                >
                  {sendingMail
                    ? campaignToken
                      ? "Sending…"
                      : "Sending…"
                    : sendMailForm.when === "schedule"
                      ? "Schedule"
                      : `Send to ${sendMailSelectedCount.toLocaleString()} contact(s)`}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Mail history modal – when, topic, status, reason (if failed) */}
      {mailHistoryRow && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4" onClick={() => setMailHistoryRow(null)}>
          <div className="bg-white rounded-xl shadow-lg max-w-4xl w-full max-h-[90vh] overflow-hidden flex flex-col" onClick={(e) => e.stopPropagation()}>
            <div className="px-6 py-4 border-b flex items-center justify-between">
              <h3 className="text-lg font-semibold text-gray-900">
                Mail history – {mailHistoryRow.firstName || mailHistoryRow.lastName ? [mailHistoryRow.firstName, mailHistoryRow.lastName].filter(Boolean).join(" ") : "Contact"} ({mailHistoryRow.email})
              </h3>
              <button type="button" onClick={() => setMailHistoryRow(null)} className="p-2 rounded-lg hover:bg-gray-100 text-gray-600">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>
              </button>
            </div>
            <div className="p-4 overflow-auto flex-1">
              {mailHistoryRow.mailSentHistory?.length ? (
                <div className="overflow-x-auto border rounded-lg">
                  <table className="min-w-full text-sm">
                    <thead className="bg-gray-50">
                      <tr>
                        <th className="border px-3 py-2 text-left whitespace-nowrap">Time</th>
                        <th className="border px-3 py-2 text-left whitespace-nowrap">Topic</th>
                        <th className="border px-3 py-2 text-left whitespace-nowrap">Subject</th>
                        <th className="border px-3 py-2 text-left whitespace-nowrap">To</th>
                        <th className="border px-3 py-2 text-left whitespace-nowrap">Status</th>
                        <th className="border px-3 py-2 text-left whitespace-nowrap">Reason (if failed)</th>
                      </tr>
                    </thead>
                    <tbody>
                      {[...(mailHistoryRow.mailSentHistory || [])]
                        .sort((a, b) => new Date(b.sentAt) - new Date(a.sentAt))
                        .map((h, idx) => {
                          const status = h.status || "sent";
                          const isFailed = status === "failed";
                          return (
                            <tr key={idx} className={isFailed ? "bg-red-50" : ""}>
                              <td className="border px-3 py-2 whitespace-nowrap">
                                {h.sentAt ? new Date(h.sentAt).toLocaleString(undefined, { dateStyle: "short", timeStyle: "short" }) : "—"}
                              </td>
                              <td className="border px-3 py-2">{h.topic || "—"}</td>
                              <td className="border px-3 py-2 max-w-[200px] truncate" title={h.subject}>{h.subject || "—"}</td>
                              <td className="border px-3 py-2">{h.to || mailHistoryRow.email || "—"}</td>
                              <td className="border px-3 py-2">
                                <span className={`inline-flex px-2 py-0.5 rounded text-xs font-medium ${isFailed ? "bg-red-100 text-red-800" : "bg-green-100 text-green-800"}`}>
                                  {isFailed ? "Failed" : "Sent"}
                                </span>
                              </td>
                              <td className="border px-3 py-2 text-red-700 max-w-[280px] truncate" title={h.failureReason || ""}>
                                {isFailed && (h.failureReason || "No reason recorded")}
                                {!isFailed && "—"}
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                </div>
              ) : (
                <p className="text-gray-500 text-center py-8">No mail history for this contact.</p>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
